import Uploader from "@edaz/edazkit/Uploader";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import Alert from "react-bootstrap/Alert";
import ExemptionViewModel from "viewModels/notice/exemption/exemptionViewModel";
import OmissionViewModel from "viewModels/notice/omission/omissionViewModel";
import LicensePlateChangeViewModel from "viewModels/notice/licensePlateChange/licensePlateChangeViewModel";
import RefundRequestViewModel from "viewModels/notice/refundRequest/refundRequestViewModel";
import FilesList from "./filesList";
import RejectedFiles from "./rejectedFiles";

const DocumentUploader: FunctionComponent<{
  vm: ExemptionViewModel | OmissionViewModel | LicensePlateChangeViewModel | RefundRequestViewModel;
  translateKey?: string;
}> = observer(({ vm, translateKey }) => {
  const tg = (code: string) =>
    vm.localizationService.translateGeneral(
      translateKey ? `documentUploader.${translateKey}.${code}` : `documentUploader.${code}`
    );

  if (!vm.documentsUploadEnabled) {
    return null;
  }

  const filesSizeErrorMessage = vm.filesSizeErrorMessage();

  return (
    <fieldset>
      <legend className="h3">{tg("title")}</legend>
      {filesSizeErrorMessage && (
        <Alert variant="danger" className="is-invalid">
          {filesSizeErrorMessage}
        </Alert>
      )}
      {vm.hasToUploadPowerOfAttorney && (
        <div className="mb-7">
          <Uploader
            onDrop={vm.addPowerOfAttorneyFiles}
            localization={vm.localizationService.translateUploader()}
            label={tg("powerOfAttorney")}
            accept={vm.allowedFileTypes}
            error={vm.powerOfAttorneyErrorMessage()}
          />
          <FilesList files={vm.notice._powerOfAttorneyFilesBase64} removeFile={vm.removePowerOfAttorneyFile} />
          <RejectedFiles
            files={vm.rejectedPowerOfAttorneyFiles}
            allowedFileTypes={vm.allowedFileTypes}
            translate={vm.localizationService.translateGeneral}
          />
        </div>
      )}
      {vm.hasToUploadTechnicalLicense && (
        <div className="mb-7">
          <Uploader
            onDrop={vm.addTechnicalLicenseFiles}
            localization={vm.localizationService.translateUploader()}
            label={tg("technicalLicense")}
            accept={vm.allowedFileTypes}
            error={vm.technicalLicenseErrorMessage()}
          />
          <FilesList files={vm.notice._technicalLicenseFilesBase64} removeFile={vm.removeTechnicalLicenseFile} />
          <RejectedFiles
            files={vm.rejectedTechnicalLicenseFiles}
            allowedFileTypes={vm.allowedFileTypes}
            translate={vm.localizationService.translateGeneral}
          />
        </div>
      )}
    </fieldset>
  );
});

export default DocumentUploader;
